import React from 'react';
import './Footer.css'; // Asigură-te că ai acest fișier CSS în același director

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-column">
          <h3>Navigație</h3>
          <ul>
            <li><a href="#acasa">Acasă</a></li>
            <li><a href="#preturi">Prețuri</a></li>
            <li><a href="#servicii">Servicii</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>Servicii</h3>
          <ul>
            <li><a href="#acasa">ITP Autoturisme</a></li>
            <li><a href="#preturi">ITP Motociclete și ATV</a></li>
            <li><a href="#servicii">Scanare și diagnoză computerizată</a></li>
            <li><a href="#contact">ITP Vehicule Utilitare</a></li>
          </ul>
        </div>

        {/* Imagini SAL & SOL */}
        <div className="footer-column footer-images">
          <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer">
            <img
              className="footer-image"
              src="https://simpixel.ro/wp-content/uploads/2022/09/SAL.svg"
              alt="SAL"
            />
          </a>
          <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.chooseLanguage" target="_blank" rel="noopener noreferrer">
            <img
              className="footer-image"
              src="https://simpixel.ro/wp-content/uploads/2022/09/SOL.svg"
              
              alt="SOL"
            />
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} Site construit de  Strugaru Andrei. <a style={{textDecoration:'none'}} href="tel:+40762057825"> Numar de telefon</a> Toate drepturile rezervate.
      </div>
    </footer>
  );
};

export default Footer;